import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import CopyRight from "src/Components/Custom/CopyRight/CopyRight";
import Footer from "src/Components/Custom/Footer/Footer";
import NavBar from "src/Components/Custom/NavBar/NavBar";
import AboutContentEn from "./AboutContentEn";
import AboutContentFr from "./AboutContentFr";
import AboutContentAr from "./AboutContentAr";

function AboutPage() {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  return (
    <Fragment>
      <header>
        <NavBar />
      </header>
      {
        lang === 'fr' 
        ? <AboutContentFr /> 
        : lang === 'ar' 
          ? <AboutContentAr /> 
          : <AboutContentEn />
      }
      <Footer />
      <CopyRight />
    </Fragment>
  );
}

export default AboutPage;
